import * as TYPES from './questionnaires-actiontypes';

export const questionnairesLoaded = (questionnaires) => ({
  type: TYPES.QUESTIONNAIRES_LOADED,
  questionnaires,
});

export const newQuestionnairesCountLoaded = (count) => ({
  type: TYPES.NEW_QUESTIONNAIRES_COUNT_LOADED,
  count,
});

export const questionnaireDetailsLoaded = (questionnaire) => ({
  type: TYPES.QUESTIONNARE_DETAILS_LOADED,
  questionnaire,
});

export const questionnaireSelected = (id) => ({
  type: TYPES.QUESTIONNAIRE_SELECTED,
  id,
});

export const questionnaireAnswerUpdated = (questionnaireId, questionnaireItemId, answerValue) => ({
  type: TYPES.QUESTIONNAIRE_ANSWER_UPDATED,
  questionnaireId,
  questionnaireItemId,
  answerValue,
});

export const questionnaireSubmitted = (questionnaire) => ({
  type: TYPES.QUESTIONNAIRE_SUBMITTED,
  questionnaire,
});

export const questionnaireValidated = (questionnaireId) => ({
  type: TYPES.QUESTIONNAIRE_VALIDATED,
  questionnaireId,
});

export const questionnaireAnswerCleared = (questionnaireId) => ({
  type: TYPES.QUESTIONNAIRE_ANSWERSCLEARED,
  questionnaireId,
});

export const setQuestionnaireFilter = (value) => ({
  type: TYPES.QUESTIONNAIRE_SET_FILTER,
  value,
});

export const historicalQuestionnairesLoaded = (historicalQuestionnaires) => ({
  type: TYPES.HISTORICAL_QUESTIONNAIRES_LOADED,
  historicalQuestionnaires,
});

export const historicalQuestionnaireDetailsLoaded = (historicalQuestionnaire) => ({
  type: TYPES.HISTORICAL_QUESTIONNARE_DETAILS_LOADED,
  historicalQuestionnaire,
});

export const kioskQuestionnairesLoaded = (kioskQuestionnaires) => ({
  type: TYPES.KIOSK_QUESTIONNAIRES_LOADED,
  kioskQuestionnaires,
});

export const questionnairesOriginUpdated = (
  questionnairesOrigin,
  questionnaireScoringPage,
  completeQuestionnairePage) => ({
  type: TYPES.QUESTIONNAIRES_ORIGIN_UPDATED,
  state: {
    questionnairesOrigin,
    questionnaireScoringPage,
    completeQuestionnairePage,
  },
});

export const kioskQuestionnairesFiltered = (facilityName) => ({
  type: TYPES.KIOSK_QUESTIONNAIRES_FILTERED,
  state: {
    facilityName,
  },
});
